import api from '../network/api';

export function serviceBlockReason(worker, risk) {
  if (!worker || Number(worker.employment_type) !== 1) {
    return 'Нельзя назначить услугу: в карточке исполнителя должен быть выбран тип занятости СМЗ.';
  }
  if (!risk || typeof risk.service_block_reason !== 'string') return 'Дождитесь проверки исполнителя в Баланс Про.';
  return risk.service_block_reason || '';
}

export default {
  mixins: [api],
  data() {
    return { workerRisks: {}, workerRisksRequest: 0 };
  },
  methods: {
    async loadWorkerRisks(ids, locationId = 0) {
      const request = ++this.workerRisksRequest;
      this.workerRisks = {};
      const uniqueIds = [...new Set(ids.filter(id => Number(id) > 0))];
      const risks = {};
      for (let offset = 0; offset < uniqueIds.length; offset += 200) {
        const batch = uniqueIds.slice(offset, offset + 200);
        const params = new URLSearchParams();
        batch.forEach(id => params.append('worker_ids[]', id));
        if (locationId > 0) params.set('location_id', locationId);
        const result = await this.get(`integration/worker_risks?${params.toString()}`);
        if (request !== this.workerRisksRequest) return;
        batch.forEach(id => {
          risks[id] = result && result.data && result.data[id] || {
            level: 'unknown',
            descriptions: ['Не удалось загрузить риски из Баланс Про.'],
            service_block_reason: 'Не удалось проверить исполнителя. Обновите данные и повторите попытку.',
          };
        });
      }
      if (request === this.workerRisksRequest) this.workerRisks = risks;
    },
    workerServiceBlockReason(worker, id) {
      return serviceBlockReason(worker, this.workerRisks[id]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/utilites/workerRisks.js